// extracted by mini-css-extract-plugin
module.exports = {"root":"CookieBanner_root__zs9V2","link":"CookieBanner_link__XfAp5"};